// Vista previa de una foto: Usar / Recortar / Repetir (recién sacada) o Listo / Recortar / Quitar (al revisar una de varias)
import React, { useRef, useState } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { Check, Crop, RotateCcw, Trash2, X } from 'lucide-react';

const recortar = (img, p, nombre) => new Promise((resolve) => {
  const sx = (p.x / 100) * img.naturalWidth;
  const sy = (p.y / 100) * img.naturalHeight;
  const sw = (p.width / 100) * img.naturalWidth;
  const sh = (p.height / 100) * img.naturalHeight;
  const c = document.createElement('canvas');
  c.width = Math.max(1, Math.round(sw));
  c.height = Math.max(1, Math.round(sh));
  c.getContext('2d').drawImage(img, sx, sy, sw, sh, 0, 0, c.width, c.height);
  c.toBlob((b) => resolve(b ? new File([b], nombre, { type: 'image/jpeg' }) : null), 'image/jpeg', 0.9);
});

const Boton = ({ onClick, principal, disabled, testid, children }) => (
  <button type="button" onClick={onClick} disabled={disabled} data-testid={testid}
    className={`h-12 px-5 rounded-full flex items-center gap-2 text-sm font-semibold transition-colors active:scale-95 disabled:opacity-40 ${principal ? 'bg-white text-gray-900' : 'bg-white/15 text-white hover:bg-white/25'}`}>
    {children}
  </button>
);

export const RevisarFoto = ({ foto, onUsar, onDescartar, revisando = false }) => {
  const [crop, setCrop] = useState(null);
  const [aplicando, setAplicando] = useState(false);
  const imgRef = useRef(null);
  const usarRecorte = async () => {
    setAplicando(true);
    onUsar((await recortar(imgRef.current, crop, foto.file.name)) || foto.file);
  };
  return (
    <div className="absolute inset-0 z-10 bg-black flex flex-col" data-testid="camara-revision">
      <div className="flex-1 min-h-0 flex items-center justify-center p-3">
        {crop ? (
          <ReactCrop crop={crop} onChange={(_, pct) => setCrop(pct)} keepSelection ruleOfThirds minWidth={30} minHeight={30}>
            <img ref={imgRef} src={foto.url} alt="Recortar foto" style={{ maxHeight: 'calc(100dvh - 120px)' }} className="max-w-full object-contain" data-testid="camara-recorte-img" />
          </ReactCrop>
        ) : (
          <img src={foto.url} alt="Foto tomada" className="max-h-full max-w-full object-contain" data-testid="camara-revision-img" />
        )}
      </div>
      <div className="flex items-center justify-around gap-2 px-4 py-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
        {crop ? (
          <>
            <Boton onClick={() => setCrop(null)} testid="camara-recorte-cancelar"><X className="h-4 w-4" /> Cancelar</Boton>
            <Boton onClick={usarRecorte} principal disabled={aplicando || !(crop.width > 0 && crop.height > 0)} testid="camara-recorte-usar"><Check className="h-4 w-4" /> Usar recorte</Boton>
          </>
        ) : (
          <>
            <Boton onClick={onDescartar} testid={revisando ? 'camara-quitar' : 'camara-repetir'}>
              {revisando ? <><Trash2 className="h-4 w-4" /> Quitar</> : <><RotateCcw className="h-4 w-4" /> Repetir</>}
            </Boton>
            <Boton onClick={() => setCrop({ unit: '%', x: 10, y: 10, width: 80, height: 80 })} testid="camara-recortar"><Crop className="h-4 w-4" /> Recortar</Boton>
            <Boton onClick={() => onUsar(foto.file)} principal testid="camara-usar"><Check className="h-4 w-4" /> {revisando ? 'Listo' : 'Usar'}</Boton>
          </>
        )}
      </div>
    </div>
  );
};
